module.exports = __webpack_public_path__ + "img/value.b237c0fd.png";